import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import { App } from './app/App';
import { AuthGate } from './app/AuthGate';
import './styles.css';

import './app/globals';
import { applyBranding, FLOW } from './app/constants';
import { userManager } from './app/oidc';
import { useStore } from './app/store';

const _hostname = window.location.hostname;
const _env = _hostname.includes('-test.')
  ? 'staging'
  : _hostname.includes('-dev.')
    ? 'development'
    : 'production';

Sentry.init({
  dsn: __SENTRY_DSN__,
  enabled: !!__SENTRY_DSN__,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  environment: _env,
  initialScope: {
    tags: { tenant: FLOW },
  },
});

applyBranding();

Object.defineProperty(window, 'state', {
  get: () => useStore.getState(),
  configurable: true,
});

// React Mount — pass the singleton userManager so AuthProvider doesn't create a second instance.
// AuthGate gates rendering on OIDC readiness so children never fire API calls before the access
// token is in storage. This eliminates the post-callback 401 → retry race.
const rootEl = document.getElementById('root');
if (rootEl) {
  const root = createRoot(rootEl);
  root.render(
    <AuthProvider
      userManager={userManager}
      onSigninCallback={() => {
        window.history.replaceState({}, '', '/');
      }}
    >
      <AuthGate>
        <App />
      </AuthGate>
    </AuthProvider>
  );
}
